import BaseFormPresenter from "../../../../base/BaseFormPresenter";

export default class NewsFormPresenter extends BaseFormPresenter {
  onChange(value, field) {
    console.log(value, field);
    if (field === "images") {
      const { images = [] } = this.change;

      this.change[field] = [...images, value];
      this.object[field] = [...images, value];
    } else {
      this.change[field] = value;
      this.object[field] = value;
    }

    this.view.setObject(this.object);
  }
}
